import { ClassroomSelfStudyPage } from "@/pages/teacher/ClassroomSelfStudyPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/self-study-record/$classroomId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId } = Route.useParams();
  return <ClassroomSelfStudyPage classroomId={classroomId} />;
}
